import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, Switch, } from 'antd';
import { XPagination, } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, tooltipClick } from '@/components/TableCell';
import { FormOutlined } from '@ant-design/icons';

class CardTable extends React.PureComponent {
    columns = () => [
        {
            title: '事件标题',
            dataIndex: 'eventName',
            key: 'eventName',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => this.props.tableAction(record.id, 'detail'))
        },
        {
            title: '任务周期',
            dataIndex: 'periodTypeDesc',
            key: 'periodTypeDesc',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '执行时间',
            dataIndex: 'issue',
            key: 'issue',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '事件数量',
            dataIndex: 'eventNum',
            key: 'eventNum',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'currentStatusDesc',
            key: 'currentStatusDesc',
            align: 'center',
            width: cellWidth.normal,
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '启用/禁用',
            dataIndex: 'status',
            key: 'status',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => (this.switchCell(text, record))
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 240,
            fixed: 'right',
            render: (id, record) => this.tableAction(id, record)
        }
    ];

    //操作
    tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(id, 'detail', record)}>查看详情</div>
                { record.allowEdit && <div className={styles.item} onClick={() => tableAction(id, 'edit')}>编辑</div>}
            </div >
        );
    };

    //状态
    switchCell = (sw, item) => {
        let checked = true;
        if (sw == '0') {
            checked = false;
        }
        return (
            <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
                checked={checked}
                onChange={(value) => {
                    this.props.tableAction(item, 'switch', value);
                }}
            />
        );
    };

    // 解析表格数据
    _takeDataSource = (data) => {
        // 解析表格数据，使符合columns格式要求
        return data && data.map(item => {
            item.issue = `${item.startTime ? item.startTime : ''} ~ ${item.endTime ? item.endTime : ''}`;//执行时间
            return item;
        });
    }


    render() {
        const { paginationChange } = this.props;
        const { dataList, pageSize, pageNum, resultTotal } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowSelection={this._rowSelection}
                    rowKey={(record) => record.id}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

CardTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default CardTable;